import React from 'react';
import Stars from 'atomic/utilization/stars';
import timeStamp from 'helpers/time-stamp';

import './product-opinion.scss';

interface ProductOpinionProps {
    rating: number;
    author: string;
    content: string;
    timestamp: number;
}

const ProductOpinion: React.FC<ProductOpinionProps> = ({ rating, author, content, timestamp }) => {
    const color = `${author}aaa`.split('')
        .reduce((acc, char) => acc * char.charCodeAt(0), 1)
        .toString(16).slice(0, 6);
    const date = timeStamp(timestamp);

    return (
        <div className="opinion">
            <div className="opinion__icon" style={{ backgroundColor: `#${color}` }}>
                {author.charAt(0)}
            </div>
            <div>
                <div className="opinion__title">
                    <span className="opinion__author">
                        {author}
                    </span>
                    {
                        date && (
                            <span className="opinion__date">
                                ,&nbsp;
                                {date}
                            </span>
                        )
                    }
                </div>
                <Stars className="sm opinion__stars" width={rating}/>
                <p className="opinion__content">
                    {content}
                </p>
            </div>
        </div>
    );
};

export default ProductOpinion;
